exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-header{background-color:#f8f9fa;font-weight:700}.w-90 .modal-dialog{max-width:90%!important;margin:0 auto!important}body{background-color:#f8f9fa}.b-container{margin-top:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fa9b12c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Pricing/newBookingResp.vue
// module id = 1428
// module chunks = 0